export var SLAStatus;
(function (SLAStatus) {
    SLAStatus[SLAStatus["PAUSED"] = 0] = "PAUSED";
    SLAStatus[SLAStatus["ACTIVE"] = 1] = "ACTIVE";
    SLAStatus[SLAStatus["COMPLETED_SUCCESSFULLY"] = 2] = "COMPLETED_SUCCESSFULLY";
    SLAStatus[SLAStatus["COMPLETED_UNSUCCESSFULLY"] = 3] = "COMPLETED_UNSUCCESSFULLY";
})(SLAStatus || (SLAStatus = {}));
//# sourceMappingURL=sla-status.enum.js.map